<div class="eiq-select__container">
  @if (label()) {
    <span class="fs__sm fw__500 label">
      {{ label() }} <span class="fs__xs caption">{{ hint() }}</span>
      @if (tooltip()) {
        <fa-icon [icon]="faInfoCircle" class="caption" [matTooltip]="tooltip()"></fa-icon>
      }
    </span>
  }

  <mat-form-field appearance="outline" class="eiq-select__field" [subscriptSizing]="'dynamic'">
    <mat-select [value]="currentValue" [multiple]="multiple()" [disabled]="control.disabled" [placeholder]="placeholder()" (selectionChange)="setValue($event)">
      @if (showDefaultOption()) {
        <mat-option>{{ defaultOption() }}</mat-option>
      }

      @if (otherOption()) {
        <mat-option [value]="otherOption().value">{{ otherOption().text }}</mat-option>
      }

      @for (optionGroup of optionGroups(); track optionGroup) {
        <mat-optgroup [label]="optionGroup.text">
          @for (option of optionGroup.value; track option) {
            <mat-option [value]="option.value">{{ option.text }}</mat-option>
          }
        </mat-optgroup>
      }
    </mat-select>
  </mat-form-field>

  @if (control.invalid && control.touched) {
    <div class="eiq-select__error mat-mdc-form-field-error">
      <eiq-validation-text [formCtrl]="control"></eiq-validation-text>
    </div>
  }
</div>
